import React, {  useState } from "react";
import { Link } from "react-router-dom";

import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import { useFormik, FormikProvider, FieldArray } from "formik";

import {  Apitoken, Authtoken } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";

const AddCalledCantacts = () => {

  const [menu, setMenu] = useState(false);
  const [backendErrors, setBackendErrors] = useState([]);


  const [headingLogistics, setHeadingLogistics] = useState(false);
  const handleAddRowLogistic = (arrayLogistics) => {
    arrayLogistics.push({
      name: "",
      position: "",
      email: "",
      phone_number:"",
    });
    setHeadingLogistics(true); // Show table headings after adding a row
  };

  const [headingQuality, setHeadingQuality] = useState(false);
  const handleAddRowQuality = (arrayQuality) => {
    arrayQuality.push({
      name: "",
      position: "",
      email: "",
      phone_number:"",
    });
    setHeadingQuality(true); // Show table headings after adding a row
  };


  const [headingBusiness, setHeadingBusiness] = useState(false);
  const handleAddRowBusiness = (arrayBusiness) => {
    arrayBusiness.push({
      name: "",
      position: "",
      email: "",
      phone_number:"",
    });
    setHeadingBusiness(true); // Show table headings after adding a row
  };

  const formik = useFormik({
    initialValues: {
  
      logistics: [],
      qualities: [],
      business: [],
    },
    //validationSchema: AddCustomerSchema,

    onSubmit: (values,{ setSubmitting }) => {
      axios
        .post("/called-contacts/add", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          
          delete backendErrors['error'];
          $("#form-submit").text("Add Contact");
   

        //  actions.setSubmitting(false);
        setSubmitting(false);

          if (response.data.code === 200) {
             toast.success(response.data.message);
           // actions.resetForm();
            setTimeout(() => {
              window.location.href = "/called-contacts";
            }, 1000);
          }  else if (response.data.code === 422) {
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
             setBackendErrors(response.data.error);
          }


        })
        .catch((error) => {
          console.log(error);
        });
    },
  });

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  // const customHandleInput = (event) => {
  //   const Input_name = event.target.name;
  //   delete backendErrors[Input_name];
  // };


  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar /><ToastContainer />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Contacts</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/called-contacts">Contacts</Link>
                    </li>
                    <li className="breadcrumb-item active">Add Contacts</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Contacts</h4>
                    <FormikProvider value={formik}>
                      <form onSubmit={formik.handleSubmit}>


                        
                          <div className="row">
                            <div className="col-md-6">
                              <h4 className="card-title">
                                <br />
                                Add Business  
                              </h4>
                            </div>
                          </div>
                        <FieldArray
                          name="business"
                          render={(arrayBusiness) => (
                            <div>
                              <button
                                className="btn btn-primary mb-3"
                                type="button"
                                onClick={() => handleAddRowBusiness(arrayBusiness)}
                              >
                                +
                              </button>
                              {headingBusiness && (
                                <table  className="table mb-0">
                                  <thead>
                                    <tr>
                                      <td>Name</td>
                                      <td>Email</td>
                                      <td>Phone Number</td>
                                      <td>Position</td>
                                      <td></td>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {formik.values.business.map(
                                      (friend, index) => (
                                        <tr key={index}>
                                          <td>
                                            <div className=" status">
                                              <input
                                                type="text"
                                                className="form-input form-control"
                                                name={`business[${index}].name`}
                                                value={
                                                  formik.values.business[index]
                                                    .name
                                                } placeholder="Full Name"
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                        
                                          <td>
                                            <div className=" status">
                                              <input
                                                type="email"
                                                className="form-input form-control"
                                                name={`business[${index}].email`}
                                                value={
                                                  formik.values.business[index]
                                                    .email
                                                }placeholder="Email"
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className=" status">
                                              <input
                                                type="text"
                                                className="form-input form-control"
                                                name={`business[${index}].phone_number`}
                                                value={
                                                  formik.values.business[index]
                                                    .phone_number
                                                }placeholder="Phone Number"
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                           <td>
                                            <div className=" status">
                                              <input
                                                type="text"
                                                className="form-input form-control"
                                                name={`business[${index}].position`}
                                                value={
                                                  formik.values.business[index]
                                                    .position
                                                }placeholder="Position"
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className="">
                                              <button
                                                  className="btn btn-danger"
                                                  type="button"
                                                  onClick={() =>
                                                    arrayBusiness.remove(index)
                                                  }
                                                >
                                                -
                                              </button>
                                            </div>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              )}
                            </div>
                          )}
                        />
                     
                    

                          <div className="row">
                            <div className="col-md-6">
                              <h4 className="card-title">
                                <br />
                                Add Logistics  
                              </h4>
                            </div>
                          </div>
                        <FieldArray
                          name="logistics"
                          render={(arrayLogistics) => (
                            <div>
                              <button
                                className="btn btn-primary mb-3"
                                type="button"
                                onClick={() => handleAddRowLogistic(arrayLogistics)}
                              >
                                +
                              </button>
                              {headingLogistics && (
                                <table  className="table mb-0">
                                  <thead>
                                    <tr>
                                      <td>Name</td>
                                      <td>Email</td>
                                      <td>Phone Number</td>
                                      <td>Position</td>
                                      <td></td>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {formik.values.logistics.map(
                                      (friend, index) => (
                                        <tr key={index}>
                                          <td>
                                            <div className=" status">
                                              <input
                                                type="text"
                                                className="form-input form-control"
                                                name={`logistics[${index}].name`}
                                                value={
                                                  formik.values.logistics[index]
                                                    .name
                                                } placeholder="Full Name"
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                         
                                          <td>
                                            <div className=" status">
                                              <input
                                                type="email"
                                                className="form-input form-control"
                                                name={`logistics[${index}].email`}
                                                value={
                                                  formik.values.logistics[index]
                                                    .email
                                                }placeholder="Email"
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className=" status">
                                              <input
                                                type="text"
                                                className="form-input form-control"
                                                name={`logistics[${index}].phone_number`}
                                                value={
                                                  formik.values.logistics[index]
                                                    .phone_number
                                                }placeholder="Phone Number"
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className=" status">
                                              <input
                                                type="text"
                                                className="form-input form-control"
                                                name={`logistics[${index}].position`}
                                                value={
                                                  formik.values.logistics[index]
                                                    .position
                                                }placeholder="Position"
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className="">
                                              <button
                                                  className="btn btn-danger"
                                                  type="button"
                                                  onClick={() =>
                                                    arrayLogistics.remove(index)
                                                  }
                                                >
                                                -
                                              </button>
                                            </div>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              )}
                            </div>
                          )}
                        />
                     
                     <div className="row">
                            <div className="col-md-6">
                              <h4 className="card-title">
                                <br />
                                Add Quality
                              </h4>
                            </div>
                          </div>
                        <FieldArray
                          name="qualities"
                          render={(arrayQuality) => (
                            <div>
                              <button
                                className="btn btn-primary mb-3"
                                type="button"
                                onClick={() => handleAddRowQuality(arrayQuality)}
                              >
                                +
                              </button>
                              {headingQuality && (
                                <table  className="table mb-0">
                                  <thead>
                                    <tr>
                                      <td>Name</td>
                                      <td>Email</td>
                                      <td>Phone Number</td>
                                      <td>Position</td>
                                      <td></td>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {formik.values.qualities.map(
                                      (friend, index) => (
                                        <tr key={index}>
                                          <td>
                                            <div className=" status">
                                              <input
                                                type="text"
                                                className="form-input form-control"
                                                name={`qualities[${index}].name`}
                                                value={
                                                  formik.values.qualities[index]
                                                    .name
                                                } placeholder="Full Name"
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                         
                                          <td>
                                            <div className=" status">
                                              <input
                                                type="email"
                                                className="form-input form-control"
                                                name={`qualities[${index}].email`}
                                                value={
                                                  formik.values.qualities[index]
                                                    .email
                                                }placeholder="Email"
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className=" status">
                                              <input
                                                type="text"
                                                className="form-input form-control"
                                                name={`qualities[${index}].phone_number`}
                                                value={
                                                  formik.values.qualities[index]
                                                    .phone_number
                                                }placeholder="Phone Number"
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className=" status">
                                              <input
                                                type="text"
                                                className="form-input form-control"
                                                name={`qualities[${index}].position`}
                                                value={
                                                  formik.values.qualities[index]
                                                    .position
                                                }placeholder="Position"
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className="">
                                              <button
                                                  className="btn btn-danger"
                                                  type="button"
                                                  onClick={() =>
                                                    arrayQuality.remove(index)
                                                  }
                                                >
                                                -
                                              </button>
                                            </div>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              )}
                            </div>
                          )}
                        />
                     
                    
                    
                 
                        <small>
                          {backendErrors.status  && (
                            <span className="form-error mt-1">
                              {backendErrors.status}
                            </span>
                          )}
                          <div>
                           
                        </div>
                        </small>
                        <div className="text-end mt-4">
                          <button type="submit"  id="form-submit" className="btn btn-primary" disabled={formik.isSubmitting}> 
                            Add Contact
                          </button>
                        </div>
                      </form>
                    </FormikProvider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AddCalledCantacts;
